export const formatBilletLine = (billetLine: string) => {
	return billetLine
		.replaceAll('_', '')
		.replaceAll('.', '')
		.trim()
		.replaceAll(' ', '');
};
